module.exports = __webpack_public_path__ + "img/logo_footer.0168ab9f.svg";